// src/components/Sidebar/SidebarHeader.jsx
import React from "react";
import { FiChevronsLeft, FiChevronsRight, FiX } from "react-icons/fi";

export default function SidebarHeader({
  collapsed,
  onToggleCollapse,
  isMobile,
  onCloseMobile,
  workspaceName = "Workspace",
}) {
  return (
    <div className="Sidebar-header">
      <div className="Sidebar-header-brand">
        <div className="Sidebar-header-logo" aria-hidden="true">
          {workspaceName.charAt(0).toUpperCase()}
        </div>
        {!collapsed && <span className="Sidebar-header-name">{workspaceName}</span>}
      </div>

      {isMobile ? (
        <button
          type="button"
          className="Sidebar-header-btn"
          onClick={onCloseMobile}
          aria-label="Close sidebar"
        >
          <FiX />
        </button>
      ) : (
        <button
          type="button"
          className="Sidebar-header-btn"
          onClick={onToggleCollapse}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          aria-pressed={collapsed}
        >
          {collapsed ? <FiChevronsRight /> : <FiChevronsLeft />}
        </button>
      )}
    </div>
  );
}
